/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import React from "react";
import { Spinner, Container } from "react-bootstrap";
import useJobInvites from "./useJobInvites";
import { useNavigate } from "react-router-dom";
import { dateDiff } from "../../../../_helpers/dateFormatter";
export default (props) => {
  const navigate = useNavigate();

  const { loading, allJobs, setLastElement, onViewJobDetails } =
    useJobInvites();

  return (
    <>
      <div className="bg-grey"></div>
      <Container className="p-0">
        <div className="hiring-process-dashboard kanban-board-main mt-4">
          <div className="col-md-12">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : Array.isArray(allJobs) && allJobs && allJobs.length > 0 ? (
              <div className="job-listing">
                <div className="row">
                  {Array.isArray(allJobs) &&
                    allJobs.map((data, index) => (
                      <div
                        className="col-md-4 mb-4"
                        key={index}
                        ref={setLastElement}
                      >
                        <div
                          className="d-flex flex-column h-100 p-4 bg-white border position-relative rounded-lg shadow-2"
                          key={data?.job_details?.id}
                        >
                          <div className="upper mb-3">
                            <div className="d-flex mb-3 align-items-start justify-content-between">
                              <div className="d-flex">
                                <img
                                  src={
                                    data?.job_posting_details &&
                                    data.job_posting_details
                                      ?.posted_by_details &&
                                    data.job_posting_details.posted_by_details
                                      ?.company_details &&
                                    data.job_posting_details.posted_by_details
                                      .company_details?.logo === null
                                      ? "/assets/images/building-placeholder.png"
                                      : data?.job_posting_details &&
                                        data.job_posting_details
                                          ?.posted_by_details &&
                                        data.job_posting_details
                                          .posted_by_details?.company_details &&
                                        data.job_posting_details
                                          .posted_by_details.company_details
                                          ?.logo
                                  }
                                  alt="company logo"
                                  className="border-radius-10 mr-3"
                                  style={{
                                    maxWidth: "48px",
                                    maxHeight: "48px",
                                  }}
                                />
                                <div className="job-info">
                                  <h3
                                    className="font-weight-medium mb-1 cursor-pointer text-capitalize text-primary"
                                    // onClick={() =>
                                    //   onViewJobDetails(data?.job_posting, null)
                                    // }
                                  >
                                    {data?.job_posting_details?.job_function}
                                  </h3>
                                  <p className="mb-1 fs-14 text-capitalize">
                                    <span className="text-muted">
                                      {data?.job_posting_details &&
                                        data.job_posting_details
                                          ?.posted_by_details &&
                                        data.job_posting_details
                                          .posted_by_details?.company_details &&
                                        data.job_posting_details
                                          .posted_by_details.company_details
                                          ?.name}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <p className="skills-list mt-2">
                              <span className="mr-2 font-weight-semi">
                                Skills:
                              </span>
                              {data?.job_posting_details &&
                              data.job_posting_details?.skill_names &&
                              Array.isArray(
                                data.job_posting_details?.skill_names
                              ) &&
                              data.job_posting_details.skill_names.length >
                                1 ? (
                                <>
                                  {Array.isArray(
                                    data?.job_posting_details &&
                                      data.job_posting_details?.skill_names &&
                                      data?.job_posting_details &&
                                      data.job_posting_details?.skill_names
                                  ) &&
                                    data?.job_posting_details &&
                                    data.job_posting_details?.skill_names &&
                                    data?.job_posting_details &&
                                    data.job_posting_details?.skill_names
                                      .slice(0, 6)
                                      .map((skill) => (
                                        <span className="skill text-muted text-capitalize">
                                          {skill}
                                        </span>
                                      ))}
                                  <p className="text-muted d-inline-block">
                                    {data?.job_posting_details &&
                                    data.job_posting_details?.skill_names &&
                                    Array.isArray(
                                      data.job_posting_details.skill_names
                                    ) &&
                                    data.job_posting_details.skill_names
                                      .length > 6
                                      ? "..."
                                      : null}
                                  </p>
                                </>
                              ) : (
                                <>Not Specified</>
                              )}
                            </p>

                            <div className="d-flex align-items-center fs-smallest text-primary mb-3">
                              <p className="mb-0 bg-light-blue text-capitalize bg-primary-light rounded-lg py-1 px-3 mr-2">
                                {data?.job_posting_details?.employment_type ? (
                                  <>
                                    {data?.job_posting_details &&
                                      data.job_posting_details
                                        ?.employment_type &&
                                      data.job_posting_details.employment_type.replace(
                                        /_/g,
                                        " "
                                      )}
                                  </>
                                ) : (
                                  "Not Mentioned"
                                )}
                              </p>

                              <p className="mb-0 bg-light-blue text-capitalize rounded-lg py-1 px-3 mr-2">
                                {data?.job_posting_details?.experience ? (
                                  <>
                                    {data?.job_posting_details &&
                                      data.job_posting_details?.experience &&
                                      data.job_posting_details.experience.replace(
                                        /_/g,
                                        " "
                                      )}
                                  </>
                                ) : (
                                  "Not Mentioned"
                                )}
                              </p>
                              <p className="mb-0 bg-light-blue text-capitalize bg-primary-light rounded-lg py-1 px-3 mr-2">
                                Remote
                              </p>
                            </div>
                          </div>
                          <div className="border-top pt-3 d-flex justify-content-between align-items-center mt-auto">
                            <p className="mb-0 mr-2 text-grey-4">
                              Invited on {dateDiff(data?.created, new Date())}{" "}
                              ago
                            </p>
                            <button
                              className="btn btn-primary px-5"
                              // onClick={() => {
                              //   navigate("/applied-jobs-expanded", {
                              //     state: {
                              //       job_id: data?.job_posting,
                              //       index: null,
                              //     },
                              //   });
                              // }}
                            >
                              View Job
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <div className="bg-grey p-4 mt-5 rounded-lg">
                <p className="font-weight-medium text-center text-danger font-weight-bold py-5">
                  No Jobs Found
                </p>
              </div>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
